import React, { PropTypes } from 'react';
import ActionCheckCircle from 'material-ui/svg-icons/action/check-circle';
import AlertError from 'material-ui/svg-icons/alert/error';
import {
  green50, green600, red600,
} from 'material-ui/styles/colors';

const styles = {
  root: {
    backgroundColor: green600,
    color: green50,
    padding: '9px 10px',
    display: 'table',
    width: '100%',
    marginBottom: 20,
  },
  iconWrapper: {
    display: 'table-cell',
    verticalAlign: 'middle',
    width: 60,
  },
  icon: {
    width: 45,
    height: 45,
    fill: green50,
    display: 'block',
  },
  message: {
    display: 'table-cell',
    verticalAlign: 'middle',
    padding: '8px 0',
  },
  clear: {
    clear: 'both',
  },
};

const Status = ({ loading, message, show }) => {
  let component = null;
  if (!loading) {
    if (message) {
      component = (
        <div style={{ ...styles.root, backgroundColor: red600 }}>
          <div style={styles.iconWrapper}>
            <AlertError style={styles.icon} />
          </div>
          <p style={styles.message}>{message.message}</p>
        </div>
      );
    } else if (show) {
      component = (
        <div style={styles.root}>
          <div style={styles.iconWrapper}>
            <ActionCheckCircle style={styles.icon} />
          </div>
          <p style={styles.message}>Sähkönjakeluverkossa ei ole alueellisia jakeluhäiriöitä.</p>
        </div>
      );
    }
  }
  return component;
};

Status.propTypes = {
  message: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
};

export default Status;



// WEBPACK FOOTER //
// ./src/components/Status.js